import { createTypedValidator } from '@takeshape/json-schema';
export const shapeName = 'TSChatPayload';
export const schema = {
    type: 'object',
    properties: {
        content: {
            type: 'string',
            description: 'The string content of the chat message.'
        },
        references: {
            type: 'array',
            items: {
                type: 'object',
                '@ref': 'TSReference'
            },
            description: 'A list of references associated with the chat message.'
        },
        artifact: {
            type: 'object',
            description: 'An optional artifact associated with the chat message.'
        }
    },
    required: ['content', 'references'],
    additionalProperties: false
};
export const validate = createTypedValidator(schema);
